import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'

const initialState = {
  moduleData: {
    PageTitle: '',
    FormFields: null,
    AlertOnNewFormSubmission: true,
    AlertEmailAddress: null,
    AlertEmailSubject: '',
    SubmitButtonLabel: '',
    SubmitSuccessMessage: '',
    SubmitErrorMessage: ''
  },
  initialModuleData: { }
}

const state = { ...initialState }

const getters = {
  moduleData: state => state.moduleData,
  initialModuleData: state => state.initialModuleData
}

const mutations = {
  [mutationNames.RESET_MODULE_DATA] (state) {
    state.moduleData = { ...initialState.moduleData }
  },
  [mutationNames.SET_MODULE_DATA] (state, moduleData) {
    state.moduleData = moduleData
    state.initialModuleData = { ...moduleData }
  },
  [mutationNames.UPDATE_MODULE_DATA] (state, payload) {
    state.moduleData = { ...state.moduleData, ...payload }
  },
  UNDO_CHANGES (state) {
    state.moduleData = { ...state.initialModuleData }
  }
}

const actions = {
  resetModuleData ({ commit }) {
    commit(mutationNames.RESET_MODULE_DATA)
  },
  async initModule ({ dispatch }, subscriptionModuleId) {
    dispatch('resetModuleData')
    const formModuleData = await api.AppModules.getFormModule(subscriptionModuleId)
    dispatch('setModuleData', formModuleData)
  },
  setModuleData ({ commit }, formModuleData) {
    commit(mutationNames.SET_MODULE_DATA, formModuleData)
  },
  updateModuleData ({ commit }, payload) {
    commit(mutationNames.UPDATE_MODULE_DATA, payload)
  },
  undoChanges ({ commit }) {
    commit('UNDO_CHANGES')
  },
  async saveFormModule ({ dispatch }, payload) {
    const response = await api.AppModules.saveFormModule(payload)
    if (response) {
      dispatch('setModuleData', payload)
    }
  },
  patchFormModule ({ getters }, payload) {
    return api.AppModules.patchFormModule(getters.moduleData.Id, payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/appModules/formModule.js